import * as Yup from "yup";
import { UserLicensesType } from "../helper/constants";

const MIN_NAME_LENGTH: number = 1;
const MAX_NAME_LENGTH: number = 150;

const AddUserValidator = Yup.object({
    firstName : Yup.string()
        .required("First Name is Required")
        .trim()
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    lastName : Yup.string()
        .required("Last Name is Required")
        .trim()
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    email : Yup.string()
        .required("Email is Required")
        .trim()
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Please provide a valid email"
        ),
    password : Yup.string()
        .min(
            10,
            `Password must be 10 characters long`
        ).test(
            "is-edit",
            "Password is required",
            function(value) {
                const { _id } = this.parent;
                return _id && !value ? false : true;
            }
        ),
    licenseList : Yup.array()
        .required("User Licences is Required")
        .test(
            "is-value-matches",
            "Invalid license values",
            function(value : string[]) {

                for(let x = 0; x < value.length; x++) { 
                    if(!UserLicensesType.includes(value[x])) {
                        return false;
                    }
                }

                return true;

            }
        ),
    organisation : Yup.string()
        .required("Organisation is Required"),
    dateAllocated: Yup.string()
        .required("Date Allocated is Required"),
    expiryDate : Yup.string()
        .required("Expiry Date is Required")
        .test(
            "is-endDate-after-startDate",
            "Expiry Date must be greater than Date Allocated",
            function (value) {
                const { dateAllocated } = this.parent;
                if (!dateAllocated || !value) {
                    return true; // Skip validation if either date is not provided
                }
                const start = new Date(dateAllocated);
                const end = new Date(value);
                return end > start;
            }
        ),
});

export default AddUserValidator;